import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "@ts-digital/vrc";
import EInvoicePreview from "../../preview/eInvoice";
import NoPreview from "../../documentDetails/noPreview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadDocument } from "../../../store/actions/download";

const PreviewDocumentModal = ({isImage, einvoiceType, setEinvoiceType, previewModal, setPreviewModal, data, isDashboard, setCurrentIndex, index}) => {
  const detail = useSelector(state => state.precog.invoiceDetail.data);
  const main = useSelector(state => state.main);
  const previewDetail = useSelector(state => state.detailsDocument?.previewDetails?.content);
  const previewloader = useSelector(state => state.detailsDocument?.previewDetails?.status?.started);

  const dispatch = useDispatch();
  
  return (
    <div className="modalPreview">
      <Modal
        visible={previewModal}
        title={"Anteprima documento"}
        onClose={e => {
          setPreviewModal(false);
        }}
        type="primary"
        outsideClosable={false}
      >
        {
          previewloader ?
            <div style={{ display: "flex", width: "300px", margin: "auto" }}>
              <div style={{ flex: "0 0 auto", margin: "auto" }}>
                <FontAwesomeIcon
                  icon={["far", "circle-notch"]}
                  style={{ fontSize: "50px", color: "#0090d1" }}
                  spin
                />
              </div>
            </div>
            :
            previewModal && previewDetail ? (

              <div className={`${isImage && "fitContent"} modalContent`} >
                { isImage &&
                <div style={{textAlign: "right"}} onClick={() => {
                  dispatch(downloadDocument(
                    detail?.doc?.id,// documentId,
                    detail?.doc?.id, // filename,
                    !isImage,
                    isImage ? "image/jpeg" : "ASSOSW",
                    "" // outputFormat
                  ));
                }}>
                  <FontAwesomeIcon
                    icon={["far", "arrow-to-bottom"]}
                    style={{
                      color:
                    previewDetail !== null ? "#0090d1" : "rgba(0,0,0,.65)",
                      fontSize: "16px",
                      cursor: previewDetail !== null ? "pointer" : "not-allowed"
                    }}
                  />
                  <span
                    className={
                      previewDetail !== null ? "download" : "downloadDisabled"
                    }
                  >
                    {" "}
                Download{" "}
                  </span>
                </div>
                }
                {
                  isImage ?
                    <img src={`data:image/jpeg;base64,${previewDetail}`} alt="preview documento" />
                    :
                    <EInvoicePreview
                      accountantSelected={main.accountantSelected}
                      accountantIdSelected={main.accountantIdSelected}
                      companySelected={main.companySelected}
                      clientIdSelected={main.clientIdSelected}
                      documentId={isDashboard ? data?.doc.id : detail?.doc.id}
                      einvoiceType={einvoiceType}
                      fileName={isDashboard ? data?.doc.id : detail?.doc.id}
                      isEinvoice={true}
                      isInModal={previewModal}
                      myType={main.myType}
                      previewContent={previewDetail}
                      isDownloadVisible={true}
                      setEinvoiceType={setEinvoiceType}
                      setCurrentIndex={setCurrentIndex}
                      index={index}
                    />
                }

              </div>
            ):
              <NoPreview />}
      </Modal>
    </div>
  );
};

export default PreviewDocumentModal;